import {
  ChangeEvent,
  CmsEmailField,
  CmsFieldType,
  CmsFileField,
  CmsModelField,
  CmsRichTextField,
  CmsTextAreaField,
  CmsTextField,
} from '@bm-js/atlascloud-shared'
import { useCmsEditorActions, useCmsEditorData } from '../../utils/hooks'
import Input from '../Input'

const CmsEditorCenterFields = () => {
  const { activeModel } = useCmsEditorData()

  return activeModel?.fields.map((modelField, i) => (
    <CmsEditorCenterField
      key={modelField.uuid}
      modelField={modelField}
      index={i}
    />
  ))
}

export default CmsEditorCenterFields

type Props = {
  modelField: CmsModelField
  index: number
}

const CmsEditorCenterField = ({ modelField, index }: Props) => {
  const { activeEntry } = useCmsEditorData()
  const { handleFieldChange } = useCmsEditorActions()

  if (!activeEntry) return null

  switch (modelField.type) {
    case CmsFieldType.TEXT: {
      const entryField = activeEntry.fields[index] as CmsTextField
      return (
        <Input
          required={modelField.required}
          type='text'
          label={modelField.label}
          value={entryField.value || ''}
          onChange={(e) => handleFieldChange(index, e)}
        />
      )
    }

    case CmsFieldType.EMAIL: {
      const entryField = activeEntry.fields[index] as CmsEmailField
      return (
        <Input
          required={modelField.required}
          type='email'
          label={modelField.label}
          value={entryField.value || ''}
          onChange={(e) => handleFieldChange(index, e)}
        />
      )
    }

    case CmsFieldType.TEXT_AREA: {
      const entryField = activeEntry.fields[index] as CmsTextAreaField
      return (
        <Input
          required={modelField.required}
          type='textarea'
          label={modelField.label}
          value={entryField.value || ''}
          onChange={(e) => {
            const event: ChangeEvent<string[]> = {
              target: {
                name: '',
                value: e.target.value.split('\n'),
              },
            }
            handleFieldChange(index, event)
          }}
        />
      )
    }

    case CmsFieldType.RICH_TEXT: {
      const entryField = activeEntry.fields[index] as CmsRichTextField
      return (
        <Input
          required={modelField.required}
          type='rich-text'
          label={modelField.label}
          value={entryField.value || ''}
          onChange={(e) => handleFieldChange(index, e)}
        />
      )
    }

    case CmsFieldType.FILE: {
      const entryField = activeEntry.fields[index] as CmsFileField
      return (
        <Input
          required={modelField.required}
          type='image'
          label={modelField.label}
          value={entryField.value}
          setter={(f) => {
            console.log('setter', f)
            handleFieldChange(index, {
              target: {
                name: modelField.key,
                value: f,
              },
            })
          }}
        />
      )
    }
  }
}
